import React from "react";
import Lottie from "lottie-react";
import defaultAnimation from "../../assets/animations/travel loading.json";

const Loader = ({ animation = defaultAnimation, size = 350, bgColor = "white" }) => {
  return (
    <div className={`flex items-center justify-center min-h-screen bg-${bgColor}`}>
      <Lottie 
        animationData={animation} 
        loop={true} 
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default Loader;
